import Button from '@rio-cloud/rio-uikit/Button';
import { type ReactNode, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { DialogType, useModal } from '@/hooks/useModal';

export interface PendingChangesModalProps {
    show: boolean;
    setShow: (show: boolean) => void;
    discardChanges: () => void;
}

export const PendingChangesModal = (props: PendingChangesModalProps): ReactNode => {
    const { show, setShow, discardChanges } = props;

    const { openDialog, closeDialog } = useModal();

    useEffect(() => {
        if (!show) {
            return;
        }

        openDialog({
            type: DialogType.SIMPLE,
            show,
            onClose: () => {
                setShow(false);
            },
            title: <FormattedMessage tagName='span' id='general.pendingChanges.title' />,
            body: <FormattedMessage tagName='span' id='general.pendingChanges.description' />,
            showCloseButton: false,
            bsSize: 'sm',
            footer: (
                <div className='btn-toolbar justify-end'>
                    <Button
                        onClick={() => {
                            setShow(false);
                            closeDialog();
                        }}
                    >
                        <FormattedMessage id='general.button.keepEditing' />
                    </Button>
                    <Button
                        onClick={() => {
                            setShow(false);
                            closeDialog();
                            discardChanges();
                        }}
                        bsStyle={'primary'}
                    >
                        <FormattedMessage id='general.button.discardChanges' />
                    </Button>
                </div>
            ),
        });
    }, [closeDialog, openDialog, show]);

    return;
};
